
// @flow
import React, {memo, useEffect, useState} from 'react';
import {Swipe} from "mirsahib-react-swipe-component";
import {randomIdentifier} from "../../../utils/helpers";

import './styles.scss';

type Props = {
    id: String,
    children: any,
    show: boolean,
    title: String,
    handleClose: any,
    closeBtn: any,
    className : String,
    disabledCustom: Boolean,
    classOverlay: String,
    bodyClassName: String,
};

const DialogComponent = ({
                            id,
                            show,
                            children,
                            title,
                            handleClose,
                            closeBtn,
                            customBtn,
                             displayClose = false,
                             handleCustom,
                            iconRedirect = '',
                            className,
                            disabledCustom,
                            classOverlay,
                            bodyClassName
                        }: Props) => {
    const [isShow, setIsShow] = useState(show)

    useEffect(() => {
        setIsShow(show);
    }, [show])

    const _handleClose = () => {
        setIsShow(false)
        if(typeof handleClose == 'function') handleClose(id, isShow)
    }

    const _handleCustom= () => {
        if(typeof handleCustom == 'function') handleCustom()
    }

    return (
        <>
            <div className={`cs-alert ${isShow ? 'show' : ''} ${className ? className : ''}`}>
                <div>
                    <h3>{title}</h3>
                    {displayClose ? (<span className="cs-popup-close-btn" onClick={_handleClose}>
                        <img src="/images/icon_close_black.svg"/>
                    </span>) : '' }
                </div>
                <div className={`cs-alert-body ${bodyClassName ? bodyClassName : ''}`}>
                    {children}
                </div>
                <div className={closeBtn && customBtn ? 'd-flex align-items-center radius-unset-btn' : ''}>
                    {(closeBtn) &&
                    <button onClick={_handleClose} className="btn btn-block btn-primary m-0 cancel">{closeBtn}</button>
                    }
                    {(customBtn) &&
                    <button onClick={_handleCustom} className="btn btn-block btn-primary m-0" disabled={disabledCustom}>
                        {customBtn}
                        {iconRedirect ? (<img className={'ml-3'} src={iconRedirect}/>) : ''}
                    </button>
                    }
                </div>
            </div>
            <div className={`cs-alert-overlay ${classOverlay && isShow ? classOverlay : ''}`}></div>
        </>
    );
};

DialogComponent.defaultProps = {
    id: randomIdentifier(),
    show: false,
    title: false,
    className : '',
    disabledCustom: false,
    classOverlay: '',
    bodyClassName: '',
};


export default DialogComponent;
